(function () {
    'use strict';
    angular.module('trakeyeApp').factory('AmcUpload', AssetUpload);

    AssetUpload.$inject = ['$http'];

    function AssetUpload($http) {

        var service = {};
        service.amcupload = function (data, callback) {

            $http.post('api/uploadFilesAMCNONAMC', data, {
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                callback(response, response.headers);
            }, function (error) {
                callback(error, error.headers);
            });
        };

		  service.uploadAssetAvailability = function (data) {
    return $http({
        method: "POST",
        url: "api/uploadFilesAssetAvailability",
        data: data,
        headers: { 'Content-Type': undefined },
        transformRequest: angular.identity,
        responseType: 'arraybuffer'
    });
};

        return service;
    }

})();